var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"info-box",class:`color-${_vm.type}`},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'circle-info'],"size":"xl"}}),_c('p',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }